import {
  setIsLoggedIn,
  setLoggedInUser,
  setLoggingIn,
} from 'actions/data/auth';
import { login } from 'api/auth';
import axios from 'axios';
import routes from 'constants/routes';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import * as authService from 'services/auth';

/**
 * Auth state Higher Order Component.
 * Use this HOC if you need to use/modify User state.
 */
function withAuthState(WrappedComponent: any) {
  class Auth extends Component<any, any> {
    /**
     * Login user and save tokens and user data.
     *
     * @param {string} email
     * @param {string} password
     */
    login = async (email: string, password: string) => {
      try {
        const { setLoggingIn, setIsLoggedIn, setLoggedInUser }: any =
          this.props;

        setLoggingIn(true);

        const { data } = await login({ email, password });

        authService.persist({
          token: data?.data?.token,
          refreshToken: data?.data?.refresh_token,
          expiryTime: data?.data?.expiration,
        });

        /**
         * Fetch permissions for a given users
         */
        setLoggingIn(false);
        setIsLoggedIn(true);
        setLoggedInUser(data?.data?.user);
        if (data?.data?.user.role_id === 4) {
          setTimeout(() => {
            window.location.href = routes.tracker.list;
          }, 0);
        } else {
          setTimeout(() => {
            window.location.href = routes.dashboard;
          }, 0);
        }
      } catch (err: any) {
        setLoggingIn(false);
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.error?.message);
        }
        throw new Error('Invalid Credentials');
      }
    };

    logout = async () => {
      authService.logout();
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          login={this.login}
          logout={this.logout}
        />
      );
    }
  }

  const mapStateToProps = (state: any) => {
    let { isLoggedIn, isLoggingIn, user, permissions } = state.data.auth;

    return {
      isLoggedIn,
      isLoggingIn,
      loggedInUser: user,
      permissions: permissions,
    };
  };

  const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators(
      { setLoggingIn, setIsLoggedIn, setLoggedInUser },
      dispatch
    );
  };

  return connect(mapStateToProps, mapDispatchToProps)(Auth);
}

export { withAuthState };
